import "./Home.module.css";
import MainNavigation from "@/reusable_sections/Header";
import ExpertiseInEveryWire from "./sections/ExpertiseInEveryWire";
import TheCurrentPulseAdvantage from "./sections/TheCurrentPulseAdvantage";
import PoweringYourSpace from "./sections/PoweringYourSpace";
import RapidResponse from "./sections/RapidResponse";
import TheSafetyStandard from "./sections/TheSafetyStandard";
import ClientExperiences from "./sections/ClientExperiences";
import FooterInformation from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <MainNavigation />
      <ExpertiseInEveryWire />
      <TheCurrentPulseAdvantage />
      <PoweringYourSpace />
      <RapidResponse />
      <TheSafetyStandard />
      <ClientExperiences />
      <FooterInformation />
    </div>;
}